import { render, staticRenderFns } from "./RagIndex.vue?vue&type=template&id=198035de&scoped=true&"
import script from "./RagIndex.vue?vue&type=script&lang=js&"
export * from "./RagIndex.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=198035de&prod&lang=less&scoped=true&"
import style1 from "../assets/v2/css/rag/workbench.less?vue&type=style&index=1&id=198035de&prod&lang=less&scoped=true&"
import style2 from "./RagIndex.vue?vue&type=style&index=2&id=198035de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198035de",
  null
  
)

export default component.exports